import React from 'react';
import {
  BanknotesIcon,
  ArrowDownTrayIcon,
  ArrowUpTrayIcon,
  ClockIcon,
} from '@heroicons/react/24/outline';

export default function SummaryCards({ formatCurrency, availableBalance, monthIn, monthOut, pendingTotal }) {
  const cards = [
    {
      label: 'Available balance',
      value: formatCurrency(availableBalance),
      icon: BanknotesIcon,
      color: 'text-primary-600',
      bg: 'bg-primary-50',
    },
    {
      label: 'Money in (this month)',
      value: formatCurrency(monthIn),
      icon: ArrowDownTrayIcon,
      color: 'text-emerald-600',
      bg: 'bg-emerald-50',
    },
    {
      label: 'Money out (this month)',
      value: formatCurrency(monthOut),
      icon: ArrowUpTrayIcon,
      color: 'text-slate-600',
      bg: 'bg-slate-100',
    },
    {
      label: 'Pending',
      value: formatCurrency(pendingTotal),
      icon: ClockIcon,
      color: 'text-amber-600',
      bg: 'bg-amber-50',
    },
  ];

  return (
    <div className="grid grid-cols-2 lg:grid-cols-4 gap-3 sm:gap-4">
      {cards.map((card) => {
        const Icon = card.icon;
        return (
          <div
            key={card.label}
            className="rounded-xl border border-slate-200/80 dark:border-slate-600 bg-white dark:bg-slate-800 p-4 shadow-sm hover:shadow-md transition-shadow"
          >
            <div className="flex items-start justify-between gap-2">
              <div className="min-w-0 flex-1">
                <p className="text-xs font-medium text-slate-500 dark:text-slate-400 uppercase tracking-wider truncate">{card.label}</p>
                <p className="mt-1 text-lg font-bold text-slate-900 dark:text-white truncate" title={card.value}>
                  {card.value}
                </p>
              </div>
              <div className={`shrink-0 rounded-lg p-2 ${card.bg} dark:bg-slate-700`}>
                <Icon className={`h-5 w-5 ${card.color} dark:text-slate-200`} />
              </div>
            </div>
          </div>
        );
      })}
    </div>
  );
}
